import React, { createContext, useContext } from "react";
import {
  Button,
  Steps,
  message,
  Typography,
  List,
  Switch,
  notification,
} from "antd";
import { Field } from "./Field";
import { Well } from "./Well";
import { Level } from "./Level";
import MonthlysettingStore from "../store/monthlysettingstore";
import SettingStore from "../store/settingstore";
import { observer } from "mobx-react-lite";
import { Link } from "@fluentui/react";
const monthlySettingStoreCtx = createContext(MonthlysettingStore);
const settingStorectx = createContext(SettingStore);
const { Step } = Steps;
const { Title } = Typography;
const _ = require("underscore");
export const AddHierarchyContainer = observer(() => {
  const settingStore = useContext(settingStorectx);
  const monthlySettingStore = useContext(monthlySettingStoreCtx);
  const [current, setCurrent] = React.useState(0);

  const steps = [
    {
      title: "Field",
      content: <Field />,
      description: "Select or enter new field",
    },
    {
      title: "Well (Conduit)",
      content: <Well />,
      description: "Select or enter new well.",
    },
    {
      title: "Level",
      content: <Level />,
      description: "Enter new level",
    },
  ];
  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const getData = () => [
    {
      title: "Enable Multiple Entries of Field,Well and Level ",
      description: <>Allow multiple hierarchy entries for a new level</>,
      actions: [
        <Switch
          checkedChildren="enable"
          unCheckedChildren="disable"
          defaultChecked={false}
          disabled
        />,
      ],
    },

    {
      title: "Enable  Advanced Querying of Monthly Report by Everyone",
      description: `Enable or disable advanced Query of monthly production data`,
      actions: [
        <Switch
          checkedChildren="enable"
          unCheckedChildren="disable"
          defaultChecked
          onClick={() => {}}
          disabled
        />,
      ],
    },

    {
      title: "Enable Hierarchy Export to Excel",
      description: `allow users to export hierarchy to excel`,
      actions: [
        <Switch
          checkedChildren="enable"
          unCheckedChildren="disable"
          defaultChecked
          disabled
        />,
      ],
    },

    {
      title: "Overwrite Exisiting Field,Well,Level ",
      description: `allow users to overwrite the existing data for a new level`,
      actions: [
        <Switch
          checkedChildren="enable"
          unCheckedChildren="disable"
          defaultChecked={false}
          disabled
        />,
      ],
    },
  ];

  const addHierachy = async () => {
    try {
      const retVal = await monthlySettingStore.save();
     
      
      monthlySettingStore.hierarchy.set(retVal.hierarchyId, retVal);
      monthlySettingStore.clearHierarchyData();
      notification.success({
        message: "SPARS Feedback",
        description: "Hierarchy data added succssfully",
      });
    } catch (error) {
      notification.error({
        key: "error",
        message: "SPARS Feedback",
        description: error && error.response && error.response.text,
      });
    }
  };
  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          {" "}
          <Title
            level={4}
            style={{
              display: "inline-block",
              marginLeft: "10px",
              fontSize: "16px",
              marginTop: "20px",
              color: "red",
            }}
          >
            Add New Field,Well or Level(String)
          </Title>
        </div>
      </div>

      <div
        className="ms-Grid-row"
        style={{
          display: "flex",
          /* justifyContent: "center",
          alignItems: "center",
          height: "80vh", */
          padding: "20px",
        }}
      >
        <div className="ms-Grid-col ms-sm12">
          <Steps current={current} size="small">
            {steps.map((item) => (
              <Step
                key={item.title}
                title={item.title}
                description={item.description}
              />
            ))}
          </Steps>
          <div className="steps-content">{steps[current].content}</div>

          <div
            className="steps-action"
            style={{
              display: "flex",
              justifyContent: current === 0 ? "flex-end" : "space-between",
            }}
          >
            {current > 0 && (
              <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
                Previous
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button
                type="primary"
                onClick={() => {
                  console.log("current", current);

                  if (
                    current === 0 &&
                    _.isEmpty(monthlySettingStore.selField.toString())
                  ) {
                    notification.info({
                      key: "error",
                      message: "SPARS Feedback",
                      description: `select or enter Field Name`,
                    });
                    return;
                  } else {
                    next();
                  }

                  if (current === 0 && _.isEmpty(monthlySettingStore.selWell.toString())) {
                    notification.info({
                      key: "error",
                      message: "SPARS Feedback",
                      description: `select or enter Field Well Name`,
                    });
                    return;
                  } else {
                    next();
                  }
                }}
              >
                Next
              </Button>
            )}

            {current === steps.length - 1 && (
              <Button
                type="primary"
                onClick={addHierachy}
                loading={monthlySettingStore.isSaving}
                disabled={
                  _.isEmpty(monthlySettingStore.selField) ||
                  _.isEmpty(monthlySettingStore.selWell) ||
                  _.isEmpty(monthlySettingStore.selLevel)
                }
              >
                Save Hierarchy
              </Button>
            )}
          </div>
        </div>
      </div>

      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          {" "}
          <Title
            level={4}
            style={{
              display: "inline-block",
              marginLeft: "10px",
              fontSize: "16px",
              marginTop: "20px",
              color: "red",
            }}
          >
            Hierarchy Modification Rules
          </Title>
        </div>
      </div>

      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <List
            itemLayout="horizontal"
            dataSource={getData()}
            renderItem={(item) => (
              <List.Item actions={item.actions}>
                <List.Item.Meta
                  title={item.title}
                  description={item.description}
                />
              </List.Item>
            )}
          />
        </div>
      </div>

      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          {" "}
          <Title
            level={4}
            style={{
              display: "inline-block",
              marginLeft: "10px",
              fontSize: "16px",
              marginTop: "20px",
              color: "red",
            }}
          >
            Input Deck Settings
          </Title>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <Link
            onClick={() => {
              settingStore.dailyProdTabSelKey = "4";
              settingStore.selectedKey = "1";
            }}
            underline
          >
            Modify Monthly Production Input deck Settings
          </Link>
        </div>
      </div>
    </div>
  );
});

